/* gz-extras.js - clean-room behavior for product-page extras
 * quantity breaks, quantity gifts, upsells, bundle offer, custom fields,
 * clickable discount, dynamic dates. Depends on core.js (GZ namespace).
 */
(function () {
  'use strict';
  if (!window.GZ || window.GZ.__extrasLoaded) return;
  var GZ = window.GZ;
  GZ.__extrasLoaded = true;

  /* ---------- helpers ---------- */
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function parseJSON(el) {
    if (!el) return [];
    try {
      return JSON.parse(el.textContent) || [];
    } catch (e) {
      return [];
    }
  }
  function money(cents, format) {
    return GZ.formatMoney(Math.max(0, Math.round(cents)), format || undefined);
  }
  function num(v, d) {
    var n = parseFloat(v);
    return isNaN(n) ? d : n;
  }
  function cssEsc(v) {
    return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/"/g, '\\"');
  }
  function formProps(formData) {
    var props = {};
    if (!formData) return props;
    formData.forEach(function (value, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m && typeof value === 'string') props[m[1]] = value;
    });
    return props;
  }
  function pushItem(items, id, quantity, props) {
    if (!id) return;
    var item = { id: Number(id) || id, quantity: quantity || 1 };
    if (props && Object.keys(props).length) item.properties = props;
    items.push(item);
  }

  /* Option matching over a product's variants JSON.
   * selects: <select> per option (position order). changedIndex: select the user touched.
   * Non-existent combos are always skipped; unavailable ones only when skipUnavailable. */
  function updateOptionClasses(selects, variants) {
    var vals = selects.map(function (s) { return s.value; });
    selects.forEach(function (select, i) {
      if (i === 0) return;
      qsa('option', select).forEach(function (opt) {
        var matches = variants.filter(function (v) {
          if (!v.options || v.options[i] !== opt.value) return false;
          for (var k = 0; k < i; k++) if (v.options[k] !== vals[k]) return false;
          return true;
        });
        opt.classList.remove('non-existent', 'unavailable');
        if (!matches.length) opt.classList.add('non-existent');
        else if (!matches.some(function (v) { return v.available; })) opt.classList.add('unavailable');
      });
    });
  }
  function resolveVariant(selects, variants, changedIndex, skipUnavailable) {
    if (!selects.length || !variants.length) return null;
    var vals = selects.map(function (s) { return s.value; });
    function matchesUpTo(v, k) {
      if (!v.options) return false;
      for (var i = 0; i < vals.length; i++) {
        if ((i <= k || i === changedIndex) && v.options[i] !== vals[i]) return false;
      }
      return true;
    }
    var variant = variants.find(function (v) { return matchesUpTo(v, vals.length - 1); }) || null;
    if (!variant || (skipUnavailable && !variant.available)) {
      for (var k = vals.length - 2; k >= -1; k--) {
        var cands = variants.filter(function (v) { return matchesUpTo(v, k); });
        var pick = cands.find(function (v) { return v.available; }) || (!skipUnavailable && !variant ? cands[0] : null);
        if (pick) {
          variant = pick;
          break;
        }
      }
      if (variant) {
        variant.options.forEach(function (o, i) {
          if (selects[i]) selects[i].value = o;
        });
      }
    }
    updateOptionClasses(selects, variants);
    return variant;
  }

  function applyVariantToSelects(selects, variants, id) {
    var v = variants.find(function (x) { return String(x.id) === String(id); });
    if (v && v.options) {
      v.options.forEach(function (o, i) {
        if (selects[i]) selects[i].value = o;
      });
    }
    updateOptionClasses(selects, variants);
  }

  function mainSubmitButton(sectionId) {
    return document.getElementById('ProductSubmitButton-' + sectionId);
  }
  function selectedQuantity(sectionId) {
    var qb = document.getElementById('quantity-breaks-' + sectionId);
    var checked = qb && qb.querySelector('input[name="quantity"]:checked');
    if (checked) return parseInt(checked.value, 10) || 1;
    var input = document.getElementById('Quantity-' + sectionId);
    if (input) return parseInt(input.value, 10) || 1;
    return 1;
  }

  /* ---------- <gz-quantity-breaks> ---------- */
  class GzQuantityBreaks extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.sectionId = this.dataset.section;
      this.variants = parseJSON(this.querySelector(':scope > script[type="application/json"]'));
      this.addEventListener('change', this.onChange.bind(this));
      qsa('.quantity-break__selector-item', this).forEach(function (item) {
        applyVariantToSelects(qsa('select', item), this.variants, item.dataset.selectedId);
      }, this);
    }

    onChange(event) {
      var target = event.target;
      if (!target.classList.contains('quantity-break__variant-select')) return;
      var item = target.closest('.quantity-break__selector-item');
      if (!item) return;
      var selects = qsa('select', item);
      var variant = resolveVariant(
        selects,
        this.variants,
        selects.indexOf(target),
        this.dataset.skipUnavailable === 'true'
      );
      if (variant) item.dataset.selectedId = variant.id;
    }

    selectedLabel() {
      var checked = this.querySelector('input[name="quantity"]:checked');
      if (!checked) return null;
      return this.querySelector('label[for="' + cssEsc(checked.id) + '"]');
    }

    /* Splits the main line into per-item variants when the break has selectors. */
    applyItems(detail) {
      var label = this.selectedLabel();
      if (!label || !detail.formData) return;
      var selectorItems = qsa('.quantity-break__selector-item', label);
      if (!selectorItems.length) return;
      var order = [];
      var counts = {};
      selectorItems.forEach(function (item) {
        var id = item.dataset.selectedId;
        if (!id) return;
        if (!counts[id]) {
          counts[id] = 0;
          order.push(id);
        }
        counts[id] += 1;
      });
      if (!order.length) return;
      var props = formProps(detail.formData);
      detail.formData.set('id', order[0]);
      detail.formData.set('quantity', String(counts[order[0]]));
      for (var i = 1; i < order.length; i++) pushItem(detail.items, order[i], counts[order[i]], props);
    }

    onVariantChange(detail) {
      var variant = detail.variant;
      if (variant && variant.options) {
        var variants = this.variants;
        qsa('.quantity-break__selector-item', this).forEach(function (item) {
          var selects = qsa('select', item);
          variant.options.forEach(function (o, i) {
            if (selects[i]) selects[i].value = o;
          });
          item.dataset.selectedId = variant.id;
          updateOptionClasses(selects, variants);
        });
      }
      if (this.dataset.updatePrices === 'false' || !detail.html || !detail.html.getElementById) return;
      var fresh = detail.html.getElementById(this.id);
      if (!fresh) return;
      var current = qsa('.variant-price-update', this);
      var next = qsa('.variant-price-update', fresh);
      if (current.length !== next.length) return;
      current.forEach(function (el, i) {
        el.innerHTML = next[i].innerHTML;
        el.classList.toggle('hidden', next[i].classList.contains('hidden'));
      });
    }
  }
  GZ.define('gz-quantity-breaks', GzQuantityBreaks);

  /* ---------- <gz-quantity-gifts> ---------- */
  class GzQuantityGifts extends HTMLElement {
    connectedCallback() {
      this.update();
    }
    update() {
      var qty = selectedQuantity(this.dataset.section);
      qsa('.quantity-gift', this).forEach(function (gift) {
        var unlocked = qty >= num(gift.dataset.quantity, 1);
        gift.classList.toggle('quantity-gift--unlocked', unlocked);
        gift.dataset.unlocked = unlocked ? 'true' : 'false';
      });
    }
    unlockedIds() {
      return qsa('.quantity-gift[data-unlocked="true"]', this)
        .map(function (g) { return g.dataset.product; })
        .filter(Boolean);
    }
  }
  GZ.define('gz-quantity-gifts', GzQuantityGifts);

  function refreshGifts(sectionId) {
    qsa('gz-quantity-gifts').forEach(function (el) {
      if (!sectionId || el.dataset.section === sectionId) {
        if (el.update) el.update();
      }
    });
  }

  /* ---------- upsell block: <product-info-upsell> ---------- */
  class ProductInfoUpsell extends HTMLElement {
    connectedCallback() {
      if (this._bound || this.classList.contains('main-offer-item')) return; // bundle items: handled by the bundle
      this._bound = true;
      var picker = this.querySelector('.upsell__variant-picker');
      this.variants = parseJSON(picker && picker.querySelector('script[type="application/json"]'));
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      if (picker) applyVariantToSelects(qsa('select', picker), this.variants, this.dataset.id);

      var form = this.querySelector('gz-product-form');
      if (form) {
        var self = this;
        form.addEventListener('gz:before-add', function (event) {
          var d = event.detail || {};
          if (!d.formData || !self.dataset.id) return;
          d.formData.set('id', self.dataset.id);
          d.formData.set('quantity', '1');
        });
      }
    }

    onClick(event) {
      if (this.dataset.toggle !== 'true') return;
      var toggle = event.target.closest('.upsell-toggle-btn');
      if (!toggle || !this.contains(toggle)) return;
      if (event.target.closest('select, a, .upsell__variant-picker')) return;
      event.preventDefault();
      this.dataset.selected = this.dataset.selected === 'true' ? 'false' : 'true';
    }

    onChange(event) {
      if (!event.target.closest('.upsell__variant-picker')) return;
      var selects = qsa('.upsell__variant-picker select', this);
      this.syncVariant(selects.indexOf(event.target));
    }

    syncVariant(changedIndex) {
      var selects = qsa('.upsell__variant-picker select', this);
      var variant = resolveVariant(selects, this.variants, changedIndex, this.dataset.skipUnavailable === 'true');
      if (!variant) return;
      this.dataset.id = variant.id;
      var btn = this.querySelector('.upsell__add-btn');
      if (btn) btn.disabled = !variant.available;
      if (this.dataset.updatePrices !== 'true') return;
      var price = variant.price * num(this.dataset.percentageLeft, 1) - num(this.dataset.fixedDiscount, 0);
      var compare = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
      var fmt = this.dataset.moneyFormat;
      qsa('.regular-price', this).forEach(function (el) { el.textContent = money(price, fmt); });
      qsa('.compare-price', this).forEach(function (el) {
        el.textContent = money(compare, fmt);
        el.classList.toggle('hidden', !(compare > price));
      });
    }
  }
  GZ.define('product-info-upsell', ProductInfoUpsell);

  /* ---------- bundle offer: <main-bundle-offer> / <bundle-deals> ---------- */
  class GzBundleOffer extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.addEventListener('change', this.onChange.bind(this));
      qsa('.bundle-deals__variant-selects-js', this).forEach(function (picker) {
        var cb = this.checkboxFor(picker);
        // remember the per-item discount ratio implied by the rendered price
        var variants = parseJSON(picker.querySelector('script[type="application/json"]'));
        var initial = cb && variants.find(function (v) { return String(v.id) === String(cb.dataset.id); });
        picker._variants = variants;
        picker._ratio = initial && initial.price > 0 ? num(cb.dataset.price, initial.price) / initial.price : 1;
        if (cb) applyVariantToSelects(qsa('select', picker), variants, cb.dataset.id);
      }, this);

      if (this.localName === 'bundle-deals') {
        var form = this.nextElementSibling;
        if (form && form.localName === 'gz-product-form') {
          form.addEventListener('gz:before-add', this.onBeforeAdd.bind(this));
        }
      }
    }

    checkboxFor(el) {
      var product = el.closest('.bundle-deals__product-js');
      return product && product.querySelector('.bundle-deals__checkbox-js');
    }

    checkedIds() {
      return qsa('.bundle-deals__checkbox-js', this)
        .filter(function (cb) { return cb.checked; })
        .map(function (cb) { return cb.dataset.id; })
        .filter(Boolean);
    }

    onChange(event) {
      var target = event.target;
      if (target.classList.contains('bundle-deals__checkbox-js')) {
        target.dataset.checked = target.checked ? 'true' : 'false';
        var wrap = target.closest('.upsell');
        if (wrap) wrap.dataset.selected = target.checked ? 'true' : 'false';
        this.updateTotals();
        return;
      }
      var picker = target.closest('.bundle-deals__variant-selects-js');
      if (!picker) return;
      var selects = qsa('select', picker);
      var variant = resolveVariant(
        selects,
        picker._variants || [],
        selects.indexOf(target),
        this.dataset.skipUnavailable === 'true'
      );
      if (!variant) return;
      var cb = this.checkboxFor(picker);
      var wrap = picker.closest('.upsell');
      if (cb) cb.dataset.id = variant.id;
      if (wrap) wrap.dataset.id = variant.id;

      var pct = wrap && wrap.dataset.percentageLeft ? num(wrap.dataset.percentageLeft, 1) : picker._ratio || 1;
      var fixed = wrap && wrap.dataset.fixedDiscount ? num(wrap.dataset.fixedDiscount, 0) : 0;
      var price = Math.max(0, variant.price * pct - fixed);
      var compare = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
      if (cb) {
        cb.dataset.price = String(Math.round(price));
        cb.dataset.comparePrice = String(compare);
      }
      if (this.dataset.updatePrices === 'true') {
        var product = picker.closest('.bundle-deals__product-js');
        var fmt = this.dataset.moneyFormat;
        qsa('.bundle-deals__price-js', product).forEach(function (el) {
          if (price > 0 || /\d/.test(el.textContent)) el.textContent = money(price, fmt);
        });
        qsa('.bundle-deals__compare-price-js', product).forEach(function (el) {
          el.textContent = compare > price ? money(compare, fmt) : '';
        });
        this.updateTotals();
      }
    }

    updateTotals() {
      if (this.dataset.updatePrices !== 'true') return;
      var totalEl = this.querySelector('.bundle-deals__total-price-js');
      if (!totalEl) return;
      var sum = 0;
      var compareSum = 0;
      qsa('.bundle-deals__checkbox-js', this).forEach(function (cb) {
        if (!cb.checked) return;
        sum += num(cb.dataset.price, 0);
        compareSum += num(cb.dataset.comparePrice, 0);
      });
      var total = Math.max(0, sum * num(this.dataset.percentageLeft, 1) - num(this.dataset.fixedDiscount, 0));
      var fmt = this.dataset.moneyFormat;
      totalEl.textContent = money(total, fmt);
      var compareEl = this.querySelector('.bundle-deals__total-compare-price-js');
      if (compareEl) compareEl.textContent = compareSum > total ? money(compareSum, fmt) : '';
    }

    /* separate bundle form: its hidden id input is empty/disabled, so we supply every line */
    onBeforeAdd(event) {
      var d = event.detail || {};
      var ids = this.checkedIds();
      if (!ids.length || !d.formData) {
        event.preventDefault();
        return;
      }
      d.formData.set('id', ids[0]);
      d.formData.set('quantity', '1');
      for (var i = 1; i < ids.length; i++) pushItem(d.items, ids[i], 1);
      var form = event.currentTarget;
      if (form.dataset.includePdpUpsells === 'true') {
        var scope = this.closest('.shopify-section') || document;
        qsa('product-info-upsell[data-toggle="true"][data-selected="true"]:not(.main-offer-item)', scope).forEach(function (u) {
          pushItem(d.items, u.dataset.id, 1);
        });
      }
    }
  }
  GZ.define('main-bundle-offer', GzBundleOffer);
  GZ.define('bundle-deals', class extends GzBundleOffer {});

  /* ---------- <gz-custom-product-field> ---------- */
  var variantAvailable = {}; // sectionId -> bool, from gz:variant-change

  class GzCustomProductField extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      var self = this;
      var onEdit = function (event) {
        self.touched = true;
        self.showError(event.type === 'change' || event.type === 'input');
        updateFieldButtons(self.dataset.section);
      };
      this.addEventListener('input', onEdit);
      this.addEventListener('change', onEdit);
      updateFieldButtons(this.dataset.section);
    }

    disconnectedCallback() {
      var sid = this.dataset.section;
      setTimeout(function () { updateFieldButtons(sid); });
    }

    input() {
      return this.querySelector('input:not([type="radio"]), textarea, select');
    }

    value() {
      if (this.dataset.type === 'pills') {
        var checked = this.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      }
      var el = this.input();
      return el ? String(el.value || '').trim() : '';
    }

    isRequired() {
      return this.dataset.required === 'true';
    }

    isValid() {
      var value = this.value();
      if (!value) return !this.isRequired();
      if (this.dataset.type === 'number') {
        var el = this.input();
        var n = parseFloat(value);
        if (isNaN(n)) return false;
        if (el.min !== '' && n < parseFloat(el.min)) return false;
        if (el.max !== '' && n > parseFloat(el.max)) return false;
      }
      return true;
    }

    showError(force) {
      var el = this.input();
      if (!el) return;
      el.classList.toggle('input--error', !!force && !this.isValid());
    }
  }
  GZ.define('gz-custom-product-field', GzCustomProductField);

  function fieldsFor(sectionId) {
    return qsa('gz-custom-product-field').filter(function (f) {
      return f.dataset.section === sectionId && typeof f.isValid === 'function';
    });
  }

  function setAtcError(btn, errorSel, labelSel, message) {
    var err = btn.querySelector(errorSel);
    var label = btn.querySelector(labelSel);
    if (err) {
      err.textContent = message || '';
      err.style.display = message ? '' : 'none';
    }
    if (label) label.style.display = message ? 'none' : '';
  }

  function toggleBlocked(btn, blocked, sectionId) {
    if (blocked) {
      if (!btn.disabled) btn.dataset.gzFieldsBlocked = 'true';
      btn.disabled = true;
    } else if (btn.dataset.gzFieldsBlocked === 'true') {
      delete btn.dataset.gzFieldsBlocked;
      var available = sectionId in variantAvailable ? variantAvailable[sectionId] : btn.dataset.unavailable !== 'true';
      if (available) btn.disabled = false;
    }
  }

  function updateFieldButtons(sectionId) {
    if (!sectionId) return;
    var fields = fieldsFor(sectionId);
    var required = fields.filter(function (f) { return f.isRequired(); });
    var invalid = required.filter(function (f) { return !f.isValid(); });
    var message = invalid.length ? invalid[invalid.length - 1].dataset.atcErrorMsg || '' : '';

    var btn = mainSubmitButton(sectionId);
    if (btn) {
      btn.dataset.requiredFields = String(required.length);
      btn.dataset.validFields = String(required.length - invalid.length);
      if (required.length) {
        setAtcError(btn, '.main-atc__error', '.main-atc__label', message);
        toggleBlocked(btn, invalid.length > 0, sectionId);
      }
    }

    var applySticky = fields.some(function (f) { return f.dataset.applyStickyAtcError === 'true'; });
    var sticky = document.getElementById('sticky-atc-' + sectionId);
    var stickyBtn = sticky && sticky.querySelector('.sticky-atc__button .main-product-atc');
    if (stickyBtn && required.length) {
      setAtcError(stickyBtn, '.sticky-atc__error', '.sticky-atc__label', applySticky ? message : '');
      toggleBlocked(stickyBtn, invalid.length > 0, sectionId);
    }
  }

  /* Returns false (abort add) when a required field is empty; otherwise writes line-item properties. */
  function applyCustomFields(sectionId, formData) {
    var fields = fieldsFor(sectionId);
    var ok = true;
    fields.forEach(function (f) {
      if (!f.isValid()) {
        ok = false;
        f.showError(true);
        return;
      }
      var value = f.value();
      if (value && formData && f.dataset.name) formData.set('properties[' + f.dataset.name + ']', value);
    });
    if (!ok) updateFieldButtons(sectionId);
    return ok;
  }

  /* ---------- <gz-clickable-discount> ---------- */
  class GzClickableDiscount extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      var code = this.dataset.code || '';
      var cookie = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      if (cookie && decodeURIComponent(cookie[1]).toLowerCase() === code.toLowerCase()) this.dataset.applied = 'true';
      var btn = this.querySelector('.clickable-discount__btn');
      if (btn) btn.addEventListener('click', this.apply.bind(this));
    }

    apply(event) {
      if (event) event.preventDefault();
      if (this.dataset.applied === 'true' || this.dataset.loading === 'true' || !this.dataset.code) return;
      var self = this;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.dataset.loading = 'true';
      this.dataset.error = 'false';
      fetch(root + 'discount/' + encodeURIComponent(this.dataset.code), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error(String(res.status));
          self.dataset.applied = 'true';
        })
        .catch(function () {
          self.dataset.error = 'true';
        })
        .then(function () {
          self.dataset.loading = 'false';
        });
    }
  }
  GZ.define('gz-clickable-discount', GzClickableDiscount);

  /* ---------- <gz-dynamic-dates> ---------- */
  function ordinal(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  class GzDynamicDates extends HTMLElement {
    connectedCallback() {
      this.render();
    }

    labels(attr) {
      return (this.dataset[attr] || '').split(',').map(function (s) { return s.trim(); });
    }

    format(date) {
      var days = this.labels('dayLabels');
      var months = this.labels('monthLabels');
      var dayName = days[(date.getDay() + 6) % 7] || ''; // labels start on Monday
      var monthName = months[date.getMonth()] || '';
      var d = date.getDate();
      var numeric = pad(d) + '. ' + pad(date.getMonth() + 1) + '.';
      switch (this.dataset.dateFormat) {
        case 'day_mm_dd': return dayName + ', ' + monthName + ' ' + ordinal(d);
        case 'day_dd_mm': return dayName + ', ' + d + '. ' + monthName;
        case 'dd_mm': return d + '. ' + monthName;
        case 'dd_mm_no_dot': return d + ' ' + monthName;
        case 'day_dd_mm_numeric': return dayName + ', ' + numeric;
        case 'dd_mm_numeric': return numeric;
        case 'mm_dd':
        default: return monthName + ' ' + ordinal(d);
      }
    }

    render() {
      var self = this;
      qsa('[data-dynamic-date]', this).forEach(function (el) {
        var text = el.dataset.text;
        if (!text) return;
        var start = new Date();
        var end = new Date();
        start.setDate(start.getDate() + num(el.dataset.minDays, 0));
        end.setDate(end.getDate() + num(el.dataset.maxDays, 0));
        el.innerHTML = text
          .split('[start_date]').join(self.format(start))
          .split('[end_date]').join(self.format(end));
      });
    }
  }
  GZ.define('gz-dynamic-dates', GzDynamicDates);

  /* ---------- document-level wiring (installed once) ---------- */

  // Main product form: custom fields, quantity-break items, upsells, bundle items, gifts.
  // Capture phase so it runs whether or not core dispatches with bubbles.
  document.addEventListener(
    'gz:before-add',
    function (event) {
      var form = event.target;
      var d = event.detail || {};
      if (!form || !form.matches || !d.formData) return;

      // generic: forms whose hidden id input ships disabled (separate ATC button)
      if (!d.formData.get('id')) {
        var idInput = form.querySelector('input.product-variant-id[disabled]');
        if (idInput && idInput.value) d.formData.set('id', idInput.value);
      }

      if (!/^ProductForm-/.test(form.id || '')) return;
      var sid = d.sectionId || form.dataset.section;
      if (!sid) return;
      if (!Array.isArray(d.items)) d.items = [];

      if (!applyCustomFields(sid, d.formData)) {
        event.preventDefault();
        return;
      }

      var qb = document.getElementById('quantity-breaks-' + sid);
      if (qb && typeof qb.applyItems === 'function') qb.applyItems(d);

      var mainId = String(d.formData.get('id') || '');
      qsa('.product-info-upsell-' + cssEsc(sid) + '[data-toggle="true"][data-selected="true"]').forEach(function (u) {
        pushItem(d.items, u.dataset.id, 1);
      });
      qsa('.main-offer-item-' + cssEsc(sid) + '[data-selected="true"]').forEach(function (u) {
        if (String(u.dataset.id) === mainId) return; // main product already in the main line
        pushItem(d.items, u.dataset.id, 1);
      });

      refreshGifts(sid);
      qsa('gz-quantity-gifts').forEach(function (g) {
        if (g.dataset.section !== sid || typeof g.unlockedIds !== 'function') return;
        g.unlockedIds().forEach(function (id) { pushItem(d.items, id, 1); });
      });
    },
    true
  );

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || !t.matches) return;
    if (t.matches('gz-quantity-breaks input[name="quantity"]')) {
      var qb = t.closest('gz-quantity-breaks');
      refreshGifts(qb && qb.dataset.section);
    } else if (t.matches('input[id^="Quantity-"]')) {
      refreshGifts(t.id.replace(/^Quantity-/, ''));
    }
  });

  document.addEventListener('gz:quantity-change', function (event) {
    refreshGifts(event.detail && event.detail.sectionId);
  });

  document.addEventListener('gz:variant-change', function (event) {
    var d = event.detail || {};
    var sid = d.sectionId;
    if (!sid) return;
    variantAvailable[sid] = !!(d.variant && d.variant.available);

    var qb = document.getElementById('quantity-breaks-' + sid);
    if (qb && typeof qb.onVariantChange === 'function') qb.onVariantChange(d);

    // quantity-breaks picker type inside gz-variant-selects: refresh per-value price texts
    var picker = document.getElementById('variant-selects-' + sid);
    var freshPicker = d.html && d.html.getElementById && d.html.getElementById('variant-selects-' + sid);
    if (picker && freshPicker && picker !== freshPicker) {
      var cur = qsa('.product-form__input--quantity-breaks .dynamic-price', picker);
      var nxt = qsa('.product-form__input--quantity-breaks .dynamic-price', freshPicker);
      if (cur.length === nxt.length) cur.forEach(function (el, i) { el.innerHTML = nxt[i].innerHTML; });
    }

    setTimeout(function () {
      updateFieldButtons(sid); // core may have re-enabled the ATC button
      // re-run the inline quantity-adjusted price script for the new base price
      var checked = qb && qb.querySelector('input[name="quantity"]:checked');
      if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();
